// extracted by mini-css-extract-plugin
export default {"stats":"Users_stats__VqP8q","blockedUser":"Users_blockedUser__nsyoa","linkContent":"Users_linkContent__Yg1ni","rowUser":"Users_rowUser__0Sr4k"};